(function($) {
  'use strict';

  const index = {
    dom: function() {
      this.$video = $('#homeVideo');
      this.$header = $('#header');
      this.$rotator = $('#heroRotator');
      this.$rotatorScroll = $('#rotator-scroll');
      this.$rotatorFixedScroll = $('#rotator-fixed-scroll');
      this.$stickyHeader = $('#sticky-header');
      this.$welcomeContent = $('#welcome-content');

      this.$galleryLoad = $('#gallery-load');
      this.$galleryExtra = $('#gallery-extra');

      this.$gallery3 = $('#gallery3');
      this.$gallery3Load = $('#gallery3-load');
      this.$gallery3Extra = $('#gallery3-extra');
    },

    truncateWelcomeContent: function() {
      var readMoreTemplate = '<a data-js-hook="truncate-toggle" style="color:inherit;border-bottom:1px solid;" href="#" aria-label="Read More">Read More &raquo;</a>';
      // var readLessTemplate = '<a data-js-hook="truncate-toggle" class="homepage__glamour-content-link" href="#" aria-label="Read Less">&laquo; Read Less</a>';
      var iTextLimit = typeof truncationLimit != 'undefined' ? truncationLimit : 500;
      var iTextLength = this.$welcomeContent.text().length;

      if (iTextLength > iTextLimit && this.$welcomeContent.text().substr(iTextLimit - iTextLength).trim()) {
        var sTruncatedText = this.$welcomeContent.html().substr(0, iTextLimit);
        var oUntractedNode = this.$welcomeContent.clone().removeAttr('id');
        this.$welcomeContent.html(sTruncatedText + '...').append(readMoreTemplate);
        this.$welcomeContent.after(oUntractedNode.hide());
      }

      // -- Can't cache. Must bind after DOM injection.
      $('[data-js-hook="truncate-toggle"]').bind('click', function(e) {
        e.preventDefault();
        $(this).parent().hide();
        $(this).parent().siblings().show();
      });
    },

    video: function() {
      let loop = 0;
      const debug = window.location.search.match(/debug-video=1/);

      if (index.$video.length) {
        var cancelled = false;
        var video = index.$video[0];
        var $fallback = $('.homepage__video-fallback');

        if (debug) {
          $('.hero__dimmer').hide();
          $('.hero__content').hide();
          $('.hero__color-overlay').hide();
          index.$video.attr('controls', true);
        }

        if (jcms.video_loop_limit != '' && jcms.video_loop_limit != null) {
          index.$video.removeAttr('loop');

          if (jcms.video_loop_limit == 'auto') {
            video.onloadedmetadata = function() {
              var duration = Math.floor(this.duration);
              jcms.video_loop_limit = duration > 180 ? 1 : Math.floor(180 / duration);

              if (debug) {
                console.log('Video loop limit (auto): ' + jcms.video_loop_limit);
              }
            };
          }
          else {
            jcms.video_loop_limit = parseInt(jcms.video_loop_limit);

            if (debug) {
              console.log('Video loop limit (explicit): ' + jcms.video_loop_limit);
            }
          }

          video.addEventListener('ended', function() {
            if (loop < jcms.video_loop_limit) {
              if (debug) {
                console.log('video looped');
              }

              this.currentTime = 0;
              this.play();
              ++loop;
            }
            else {
              if (index.$video.data('fallback-to-rotator') == 1) {
                $('.hero__slides').show();
                $('.hero__video').hide();

                if (index.$rotator.length) {
                  index.$rotator.trigger('set-image-height');
                }
              }
              else {
                video.src = '';
              }

              if (debug) {
                console.log('video loop limit reached');
              }
            }
          });
        }
        else if (debug) {
          console.log('Video loop limit: none');
        }
      }
    },

    rotator: function() {

      if (typeof rotatorSettings !== 'undefined' && this.$rotator.length) {
        this.$rotator.flexslider({
          slideshowSpeed: rotatorSettings.speed, controlNav: rotatorSettings.controlNav, directionNav: rotatorSettings.directionNav, selector: '.hero__slides > li', namespace: 'hero__', prevText: jcms.settings.navPrev, nextText: jcms.settings.navNext, start: function(slider) {
            if (slider.count < 2) {
              if (typeof slider.controlNavScaffold != 'undefined') {
                slider.controlNavScaffold.remove();
                index.$rotator.closest('.section').removeClass('nav-control');
              }
              if (slider.directionNav && typeof slider.directionNav[0] != 'undefined') {
                $(slider.directionNav[0]).closest('ul').remove();
                index.$rotator.closest('.section').removeClass('nav-direction');
              }
            }
            if (slider.count > 1) {
              slider.slides.eq(slider.currentSlide).addClass('animate-slide');
            }
          }, before: function(slider) {
            slider.slides.eq(slider.animatingTo).addClass('animate-slide');
          }, after: function(slider) {
            var prevSlide = slider.currentSlide === 0 ? slider.last : slider.currentSlide - 1;
            slider.slides.eq(prevSlide).removeClass('animate-slide');
          }
        });
      }
    },

    rotatorScroll: function() {
      var headerHeight;

      $(window).on('load resize scroll', function(event) {
        if (!index.$rotator.length) { return; }
        const scrollBottom = Math.ceil($(window).scrollTop() + $(window).height());
        const rotatorBottom = Math.ceil(index.$rotator.offset().top + index.$rotator.height());

        if (event.type == 'load' || event.type == 'resize') {
          headerHeight = $(window).height() - index.$header.outerHeight();
        }

        index.$rotatorFixedScroll.css({
          position: rotatorBottom < scrollBottom ? 'absolute' : 'fixed', bottom: rotatorBottom > scrollBottom ? 'auto' : 0, height: headerHeight, width: rotatorBottom < scrollBottom ? '100%' : ''
        });
      });

      this.$rotatorScroll.click(function(e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: index.$stickyHeader.length ? index.$rotator.outerHeight() - index.$stickyHeader.outerHeight() : index.$rotator.height()
        });
      });
    },

    gallery: function() {

      this.$galleryLoad.click(function(e) {
        e.preventDefault();
        $(this).hide();
        index.$galleryExtra.slideDown();

        if ($('.isotope-grid').length) {
          $('.isotope-grid').isotope('layout');
        }
      });
    },

    masonryGallery: function() {

      if (index.$gallery3.length) {
        index.$gallery3.isotope({
          itemSelector: '.grid-item', layoutMode: 'masonry'
        });

        if (index.$gallery3Extra.length) {
          var $moreGallery = $(index.$gallery3Extra.html());

          this.$gallery3Load.click(function(e) {
            e.preventDefault();
            $(this).hide();
            index.$gallery3.append($moreGallery).isotope('appended', $moreGallery);

            var myLazyLoadBG = new LazyLoad({
              container: index.$gallery3.get(0)
            });
          });
        }
      }
    },

    ready: function() {
      this.dom();
      this.video();
      this.rotator();
      this.rotatorScroll();
      this.gallery();
      this.masonryGallery();
      this.truncateWelcomeContent();
    }
  };

  $(function() {
    index.ready();
  });

})(jQuery);
